<script setup>
// [PROSPEK] 2026-04-05 Add computed, watch, timeStampAppendedURL for delayed attachment reactivity
import { computed, ref, watch } from 'vue';
// [/PROSPEK]
import Icon from 'next/icon/Icon.vue';
import { useSnakeCase } from 'dashboard/composables/useTransformKeys';
import { useMessageContext } from '../provider.js';
// [PROSPEK] 2026-04-05 Cache-bust delayed attachment URLs
import { timeStampAppendedURL } from 'dashboard/helper/URLHelper';
// [/PROSPEK]

import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';

// [PROSPEK] 2026-04-05 Capture props for reactive watch
const props = defineProps({
  attachment: {
    type: Object,
    required: true,
  },
});
// [/PROSPEK]
const hasError = ref(false);
const showGallery = ref(false);

const { filteredCurrentChatAttachments } = useMessageContext();

// [PROSPEK] 2026-04-05 Cache-busted URL for delayed attachment reactivity
const mediaUrl = computed(() => {
  return props.attachment?.dataUrl
    ? timeStampAppendedURL(props.attachment.dataUrl)
    : '';
});
// [/PROSPEK]

// [PROSPEK] 2026-04-05 Reset thumbnail error state when delayed attachment updates arrive
watch(
  () => props.attachment,
  () => {
    hasError.value = false;
  },
  { immediate: true }
);
// [/PROSPEK]

const handleError = () => {
  hasError.value = true;
};
</script>

<template>
  <div
    class="size-[72px] overflow-hidden contain-content rounded-xl cursor-pointer"
    @click="showGallery = true"
  >
    <div
      v-if="hasError"
      class="flex flex-col items-center justify-center gap-1 text-xs text-center rounded-lg size-full bg-n-alpha-1 text-n-slate-11"
    >
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      {{ $t('COMPONENTS.MEDIA.LOADING_FAILED') }}
    </div>
    <img
      v-else
      class="object-cover w-full h-full skip-context-menu"
      :src="mediaUrl"
      @error="handleError"
    />
  </div>
  <GalleryView
    v-if="showGallery"
    v-model:show="showGallery"
    :attachment="useSnakeCase(attachment)"
    :all-attachments="filteredCurrentChatAttachments"
    @error="handleError"
    @close="() => (showGallery = false)"
  />
</template>
